// Tải file mẫu và đọc file Excel người dùng nhập, dùng chung cho các trang công lương.
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/** Ngày trong file Excel: ô ngày, số kiểu Excel hoặc chuỗi DD/MM/YYYY. Ô trống trả null, sai dạng trả undefined. */
export function parseExcelDate(value) {
    if (value === null || value === undefined || value === '') return null;
    if (value instanceof Date) return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    if (typeof value === 'number') {
        const date = new Date(Math.round((value - 25569) * 86400 * 1000));
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    }
    const match = String(value).trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) return undefined;
    const date = new Date(+match[3], +match[2] - 1, +match[1]);
    return date.getDate() === +match[1] && date.getMonth() === +match[2] - 1 ? date : undefined;
}

/** sheets: [{ name, rows: [[...tiêu đề], [...dòng]] }] */
export function downloadWorkbook(fileName, sheets) {
    const workbook = XLSX.utils.book_new();
    for (const { name, rows } of sheets) {
        const sheet = XLSX.utils.aoa_to_sheet(rows);
        sheet['!cols'] = (rows[0] ?? []).map((title) => ({ wch: Math.max(12, String(title).length + 2) }));
        XLSX.utils.book_append_sheet(workbook, sheet, name);
    }
    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), fileName);
}

/** Đọc sheet đầu tiên thành các object theo dòng tiêu đề. */
export function readFirstSheet(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const workbook = XLSX.read(event.target.result, { type: 'array', cellDates: true });
                resolve(XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { defval: '', raw: true }));
            } catch (error) {
                reject(new Error(`Không đọc được file Excel: ${error.message}`));
            }
        };
        reader.onerror = () => reject(new Error('Không đọc được file.'));
        reader.readAsArrayBuffer(file);
    });
}
